import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="pageContainer">
      <h1>Privacy Policy</h1>

      <p>
        <strong>Effective Date:</strong> May 21, 2025
      </p>

      <p>
        Thank you for using easyzilla! We are committed to protecting your
        personal information and your right to privacy. This Privacy Policy
        explains how we collect, use, and safeguard your information when you
        use our web app to sign up and create webpages.
      </p>

      <h2>1. Information We Collect</h2>
      <p>When you use our app, we may collect the following information:</p>
      <ul>
        <li>
          <strong>Account Information:</strong> Your name, email address, and
          password when you create an account.
        </li>
        <li>
          <strong>Webpage Content:</strong> Any text, images, or other content
          you submit to create your webpages.
        </li>
        <li>
          <strong>Usage Data:</strong> Basic analytics data such as your browser
          type, pages visited, and time spent on the site (used to improve
          performance and user experience).
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Create and manage your account.</li>
        <li>
          Provide the features of the web app (e.g., creating and storing
          webpages).
        </li>
        <li>Improve our services, fix bugs, and develop new features.</li>
        <li>
          Communicate with you about updates or issues related to your account.
        </li>
      </ul>

      <h2>3. Data Sharing and Disclosure</h2>
      <p>
        We{" "}
        <strong>
          do not share, sell, or rent your personal information to any third
          parties
        </strong>{" "}
        without your explicit consent.
      </p>
      <p>
        Your content and data remain yours. We will only share your information:
      </p>
      <ul>
        <li>If you give us permission.</li>
        <li>If required by law or legal process.</li>
        <li>
          To protect the rights, property, or safety of you, us, or others.
        </li>
      </ul>

      <h2>4. Cookies and Tracking Technologies</h2>
      <p>
        We may use basic cookies to remember your login session or collect
        non-personal usage data. You can control cookie settings through your
        browser.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain your data only as long as your account is active or as needed
        to provide our services. You can delete your account at any time, which
        will remove your personal data and associated webpages from our systems.
      </p>

      <h2>6. Security</h2>
      <p>
        We use industry-standard security practices to protect your data,
        including encryption and secure authentication. However, no system is
        100% secure, so we encourage you to use a strong password and keep your
        login credentials confidential.
      </p>

      <h2>7. Your Rights</h2>
      <p>Depending on your location, you may have the right to:</p>
      <ul>
        <li>Access or download your data.</li>
        <li>Request corrections or deletions.</li>
        <li>Withdraw consent for data processing.</li>
        <li>File a complaint with a data protection authority.</li>
      </ul>
      <p>
        Contact us at{" "}
        <a href="mailto:hello@easyzilla.com">hello@easyzilla.com</a> for any
        privacy-related requests.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. If we make
        significant changes, we’ll notify you via the app or email.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, contact
        us at:
      </p>
      <p>
        <strong>Email:</strong>{" "}
        <a href="mailto:hello@easyzilla.com">hello@easyzilla.com</a>
      </p>
      <br />
      <p>
        <Link to="/">Back to home</Link>
      </p>
    </div>
  );
}
